import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-input-number-up",
  "use": "icon-input-number-up-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 9\" fill=\"none\" id=\"icon-input-number-up\">\n  <path d=\"M6.9689 5.53025L4.78484 2.9815C4.74963 2.94044 4.70596 2.90748 4.65682 2.88488C4.60768 2.86229 4.55424 2.85059 4.50015 2.85059C4.44606 2.85059 4.39262 2.86229 4.34348 2.88488C4.29434 2.90748 4.25067 2.94044 4.21546 2.9815L2.0314 5.53025C1.82296 5.77353 1.99577 6.14931 2.31609 6.14931H6.68484C7.00515 6.14931 7.17796 5.77353 6.9689 5.53025Z\" fill=\"#E1E2E6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol